'use client';

import RelatedProducts from '@/components/RelatedProducts';
import useIsMobile from '@/hooks/use-is-mobile';

const UpsellProductSlider = ({ products }: { products: any[] }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <RelatedProducts products={products} />;
  }

  return (
    <div>
      <p className='mb-[15px] pl-2.5 text-lg uppercase leading-[22px]'>finish your look</p>
      <RelatedProducts
        slidesToShow={4}
        products={products}
        hideProductName
        showCustomizeOptions
        classNames={{
          root: '[&_.slick-arrow]_pt-[calc((100%_-_64px)_/_4_/_384_*_283_-_20px)]',
        }}
      />
    </div>
  );
};

export default UpsellProductSlider;
